<template>
  <layout width="540" :dividers="false">
    <template slot="header">
      {{ title }}
    </template>

    <template>
      <v-form>
        <v-text-field v-model="state.lon" label="Longitude" />
        <v-text-field v-model="state.lat" label="Latitude" />
        <v-text-field v-if="!hideAlt" v-model="state.alt" label="Altitude" />
      </v-form>
    </template>
    <template slot="footer">
      <v-spacer />
      <v-btn text color="text-primary" @click.stop="$emit('close')">
        Cancel
      </v-btn>
      <v-btn
        text
        color="primary"
        depressed
        :loading="loading"
        @click.stop="handleConfirm"
      >
        {{ confirmText }}
      </v-btn>
    </template>
  </layout>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api';
import layout from './PopupLayoutDefault';
export default {
  name: 'PopupCoordinateEdit',
  components: {
    layout
  },
  props: {
    title: {
      type: String,
      default: 'Edit coordinate'
    },
    lon: {
      type: [String, Number],
      default: 0
    },
    lat: {
      type: [String, Number],
      default: 0
    },
    alt: {
      type: [String, Number],
      default: 0
    },
    hideAlt: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: 'Save'
    },
    onConfirm: {
      type: Function,
      default: () => {}
    }
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const state = ref({
      lat: 0,
      lon: 0,
      alt: 0
    });
    const handleCancel = () => {
      emit('close');
    };
    const handleConfirm = async () => {
      try {
        loading.value = true;
        await props.onConfirm(state.value);
        loading.value = false;
        emit('close');
      } finally {
        loading.value = false;
      }
    };
    onMounted(() => {
      state.value = {
        lon: props.lon,
        lat: props.lat,
        alt: props.alt
      };
    });
    return {
      handleConfirm,
      handleCancel,
      loading,
      state
    };
  }
};
</script>

<style lang="sass" scoped>
::v-deep
  .form-subheader:first-child
    margin-top: -16px
</style>
